import { useCallback } from 'react'

import useUser from '@/hooks/useUser'
import logger from '@/lib/vouchLogger'

type TrackMetaData = {
  subjectId?: string
  customerId?: string
  fileName?: string
}

type TrackArgs = {
  personId: string
  trackingName: string
  metadata?: TrackMetaData
}

export const track = ({ personId, trackingName, metadata }: TrackArgs) => {
  logger.info('Tracked activity', {
    personId,
    trackingName,
    ...metadata,
  })
}

export const useUserTracking = () => {
  const { personId } = useUser()

  const trackUserActivity = useCallback(
    (trackingName: string, metadata?: TrackMetaData) =>
      track({ personId, trackingName, metadata }),
    [personId],
  )

  return {
    trackUserActivity,
  }
}
